export const PRODUCT_TAGS = {
  // @i18n-ignore
  SOLD_OUT: 'Sold Out',
  // @i18n-ignore (compare using .toLowerCase())
  APP_EXCLUSIVE: 'app exclusive',
}
